import { track, trackingEvents } from 'modules/core/lib/Tracking'

import { type Section } from 'modules/expenses/lib/RouteContextParams'

type BasicType = number | string | boolean

export const trackFilters = (
  filterUsed: string,
  context: Section,
  values?: BasicType | BasicType[]
) => {
  track(trackingEvents.expenses.filterExpenses, {
    filter_used: filterUsed,
    context,
    values,
  })
}
